import { useQuery } from '@tanstack/react-query';
import AlpacaApi from '../apis/alpaca_api';

export const alpacaKeys = {
  all: ['alpacas'],
  allDataOnly: ['alpacasDataOnly'],
  view: (view: string) => [...alpacaKeys.all, 'view', view],
  searches: () => [...alpacaKeys.all, 'search'],
  search: (text: string) => [...alpacaKeys.all, 'search', text],
  farms: () => [...alpacaKeys.all, 'farms'],
  farmList: (farmId: number) => [...alpacaKeys.farms(), farmId],
  events: () => [...alpacaKeys.all, 'events'],
  eventList: (eventId: number) => [...alpacaKeys.events(), eventId],
  details: () => [...alpacaKeys.all, 'detail'],
  detail: (alpacaId: number) => [...alpacaKeys.details(), alpacaId],
  dataOnly: (alpacaId: number) => [...alpacaKeys.detail(alpacaId), 'dataOnly'],
};

export const sireAncestorKeys = {
  all: ['sireAncestors'],
  for: (alpacaId: number) => [...sireAncestorKeys.all, alpacaId],
};
export const damAncestorKeys = {
  all: ['damAncestors'],
  for: (alpacaId: number) => [...damAncestorKeys.all, alpacaId],
};

export function useAlpacas(search: string) {
  return useQuery({
    queryKey: alpacaKeys.view(search),
    queryFn: async () => await AlpacaApi.getAlpacas(search),
  });
}
export function useAlpacasDataOnly() {
  return useQuery({
    queryKey: alpacaKeys.allDataOnly,
    queryFn: async () => await AlpacaApi.getAlpacasDataOnly(),
  });
}

export function useAlpaca(id: number) {
  return useQuery({
    queryKey: alpacaKeys.detail(id),
    queryFn: async () => await AlpacaApi.getAlpaca(id),
    enabled: !!id,
  });
}
export function useAlpacaDataOnly(id: number) {
  return useQuery({
    queryKey: alpacaKeys.dataOnly(id),
    queryFn: async () => await AlpacaApi.getAlpacaDataOnly(id),
    enabled: !!id,
  });
}

export function useAlpacasForFarm(farmId: number) {
  return useQuery({
    queryKey: alpacaKeys.farmList(farmId),
    queryFn: async () => await AlpacaApi.getAlpacasByFarmId(farmId),
    enabled: !!farmId,
  });
}
